import { useEffect, useState } from 'react';

import { useIdentity } from '../IdentityProvider/IdentityProvider';
import { getASDClient } from '../../services/asd';

import type { ASDClient } from '@vgtv/asd-client';

export const useASDClient = (callback: () => void) => {
  const { sessionData } = useIdentity();
  const [asdClient, setAsdClient] = useState<ASDClient>();

  const userId = sessionData?.userId;

  useEffect(() => {
    if (!userId) {
      return;
    }

    (async () => {
      try {
        const asd = await getASDClient(String(userId), callback);

        setAsdClient(asd);
      } catch (err) {
        console.error(err);
      }
    })();
  }, [userId]); // eslint-disable-line react-hooks/exhaustive-deps

  return { asdClient };
};
